import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import type { TopologyEdgeSettings } from '@ipfabric/utils';
import {
  type GraphState,
  isTopologyProtocolSettings,
} from 'components/Graph/GraphState';
import type { Draft } from 'immer';

export const getEdgeSettings = (
  draft: Draft<GraphState>,
  groupIndex: number,
  protocolIndex: number,
): TopologyEdgeSettings | null => {
  const { presetDraft } = draft.layoutSettings;
  // Other protocols
  if (groupIndex === -1) {
    const edges = presetDraft.edges.filter(isTopologyProtocolSettings);
    // Fixed noUncheckedIndexedAccess NIM-19408
    return edges[protocolIndex]!;
  }
  // Protocol in group
  const foundGroup = presetDraft.edges[groupIndex];
  if (foundGroup?.type === 'group') {
    const foundEdge = foundGroup.children[protocolIndex];
    if (foundEdge !== undefined && isTopologyProtocolSettings(foundEdge)) {
      return foundEdge;
    }
    stumble('Non topology protocol found in topology group');
  }
  return null;
};

export const insertEdgeSettings = (
  draft: Draft<GraphState>,
  groupIndex: number,
  protocolIndex: number,
  edge: TopologyEdgeSettings,
): void => {
  const { presetDraft } = draft.layoutSettings;
  // Other protocols
  if (groupIndex === -1) {
    if (protocolIndex === -1) {
      presetDraft.edges.push(edge);
      return;
    }
    const groupsLength = presetDraft.edges.filter(
      (item) => item.type === 'group',
    ).length;
    presetDraft.edges.splice(protocolIndex + groupsLength, 0, edge);
    return;
  }
  // Protocol in group
  const foundGroup = presetDraft.edges[groupIndex];
  if (foundGroup?.type === 'group') {
    if (protocolIndex === -1) {
      foundGroup.children.push(edge);
    } else {
      foundGroup.children.splice(protocolIndex, 0, edge);
    }
  }
};

export const deleteEdgeSettings = (
  draft: Draft<GraphState>,
  groupIndex: number,
  protocolIndex: number,
): void => {
  const { presetDraft } = draft.layoutSettings;
  // Other protocols
  if (groupIndex === -1) {
    if (protocolIndex === -1) {
      return;
    }
    const groupsLength = presetDraft.edges.filter(
      (item) => item.type === 'group',
    ).length;
    presetDraft.edges.splice(protocolIndex + groupsLength, 1);
    return;
  }
  // Protocol in group
  const foundGroup = presetDraft.edges[groupIndex];
  if (foundGroup?.type === 'group') {
    foundGroup.children.splice(protocolIndex, 1);
  }
};
